function getDeliveryData(datapath, callBackFn) {
    var xmlhttp = new XMLHttpRequest();
    xmlhttp.open('GET', datapath, true);
    xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == 4) {
            if (xmlhttp.status == 200) {
                var obj = JSON.parse(xmlhttp.responseText);
                callBackFn(obj);
            }
        }
    };
    xmlhttp.send(null);
}

function arrayUniqueFilter(value, index, self) {
    return self.indexOf(value) === index;
}

var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

function toOrdinal(number) {
    switch (number % 100) {
        case 11:
        case 12:
        case 13:
            return number + "th";
    }

    switch (number % 10) {
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
        default:
            return number + "th";
    }
}
var getAbsoluteDate = function (date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate())
}

function isWorkingDay(dateToCheck, weekDays, holidays) {
    var date = getAbsoluteDate(dateToCheck);
    var isWeekday = weekDays.indexOf(date.getDay()) !== -1;
    var isHoliday = holidays.indexOf(date.getTime()) !== -1;

    return isWeekday && !isHoliday;
}

function getHolidays(inputHolidays) {
    return inputHolidays.map(function (item) { return moment(item, "DD-MM-YYYY").toDate().getTime() });
}

function findDeliveryDate(dispatchDate, cData){
    var holidays = getHolidays(cData.holidays);
    var deliveryOptions = [];
    cData.deliveryOptions.forEach(function (value) {
        if (value.days_to_show.indexOf((dispatchDate).getDay()) == -1) {
            deliveryOptions.push({
                deliverydate: dispatchDate,
                title: value.title,
                show: false,
                deliverOnTomorrowMessage: value.deliverOnTomorrowMessage
            });
            return true;
        }
        deliveyDate = dispatchDate;
        var daysToAdd = value.days_to_add;
        for (i = 0; i < daysToAdd; i++) {
            deliveyDate = moment(deliveyDate).add(1, 'days').toDate();
            while (!isWorkingDay(deliveyDate, value.delivery_days, holidays)) {
                deliveyDate = moment(deliveyDate).add(1, 'days').toDate();
            }
        }
        deliveryOptions.push({ id: value.id, deliverydate: deliveyDate, title: value.title, prependText: value.prependText, show: true, deliverOnTomorrowMessage: value.deliverOnTomorrowMessage });
    });
    deliveryOptions = deliveryOptions.filter(function(item){ return item.show}).sort(function(item1, item2){return item1.deliverydate.getTime() - item2.deliverydate.getTime()});
    return { dispatchDate: dispatchDate, deliverydate : deliveryOptions[0].deliverydate, title: deliveryOptions[0].title };
}

function processCheckoutData(cData, postcode) {
    var holidays = getHolidays(cData.holidays);

    var deliveryInfo = []
    var loopVar = true;
    var checkDate = new Date();

    var dispatchDate = findDispatchDate(checkDate, cData, holidays);

    var di  = findDeliveryDate(dispatchDate, cData);
	return di;
}


function findDispatchDate(checkDate, cData, holidays) {
    var cutoffDateTime = moment(getAbsoluteDate(checkDate));

    var cutoffSetting = cData.cutoff.split(":");
    if (cutoffSetting[0]) {
        cutoffDateTime.add(cutoffSetting[0], "hour");
    }
    if (cutoffSetting[1]) {
        cutoffDateTime.add(cutoffSetting[1], "minute");
    }

    var date = checkDate;
    if (cutoffDateTime.diff(date) < 0) {
        date = moment(date).add(1, 'days').toDate();
    }
    while (!isWorkingDay(date, cData.smiffysWorkingDays, holidays)) {
        date = moment(date).add(1, 'days').toDate();
    }

    var result = moment(getAbsoluteDate(date));
  
  	if (cutoffSetting[0]) {
        result.add(cutoffSetting[0], "hour");
    }
    if (cutoffSetting[1]) {
        result.add(cutoffSetting[1], "minute");
    }
  
    return result.toDate();
}

if(deliveryTimeOut){
	clearInterval(deliveryTimeOut);
}
var deliveryTimeOut;


function processData(data) {
    deliveryOpt = processCheckoutData(data, '');
  if(!deliveryOpt.dispatchDate || !deliveryOpt.deliverydate){
    debugger;
  }
  	deliveryTimeOut = setInterval(function() {showTime(deliveryOpt.dispatchDate, deliveryOpt.deliverydate)}, 1000);
    showTime(deliveryOpt.dispatchDate, deliveryOpt.deliverydate);  
}

var datapathStr="";
function deliveryEstimate(datapath) {
  datapathStr = datapath;
  var checkoutDeliveryData = null;
  getDeliveryData(datapath,processData);
}

function topBarDeliveryDateName(deliveryDate){
  var tomorrow = getAbsoluteDate(moment(new Date()).add(1, "days").toDate());
  return (tomorrow.getTime() === getAbsoluteDate(deliveryDate).getTime())? "NEXT DAY" : dayNames[deliveryDate.getDay()];;
}

function productPageDeliveryDateName(deliveryDate){
  return dayNames[deliveryDate.getDay()] + ", " + deliveryDate.getDate() + " " + monthNames[deliveryDate.getMonth()];
}

function showTime(countDownDate, deliveryDate){
  var cutoffTime = generateCutoffTimeString(countDownDate);
  var headerBanner = document.querySelector('#shopify-section-announcement-bar > div');
  if(headerBanner){
  	headerBanner.innerHTML =
    	"<i class='fas fa-shipping-fast'></i> Order " + cutoffTime.message + " for " + topBarDeliveryDateName(deliveryDate) + " delivery <a style='color:red' href='/pages/delivery-update'>*</a>";
  }
  var headerBanner = document.querySelector('#header > div.promo_banner > p');
  if(headerBanner){
  	headerBanner.innerHTML =
    	"<strong><i class='fas fa-shipping-fast'></i> Order " + cutoffTime.message + " for " + topBarDeliveryDateName(deliveryDate) + " delivery</strong> <a style='color:red' href='/pages/delivery-update'>*</a>";
  }
  
  //Want it by Tuesday, 10 March? Order within 3 hours and 52 mins
  var productPagecountdown = document.querySelector('.deliverycountdown');
  if(productPagecountdown){
  	productPagecountdown.innerHTML = 
    "<i class='fas fa-shipping-fast'></i> Want it <span class='day_string'>"+ productPageDeliveryDateName(deliveryDate)  + "</span>? Order " + cutoffTime.message;
  }
  
  // If the count down is over, write some text 
  if (cutoffTime.distance < 0) {
    clearInterval(deliveryTimeOut);
    deliveryEstimate(datapathStr);
  }
}

function generateCutoffTimeString(countDownDate){
  // Get today's date and time
  var now = new Date().getTime();
    
  // Find the distance between now and the count down date
  var distance = countDownDate - now;
  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
  if(days > 0){
    hours = hours + (days * 24);
    days = 0;
  }
  
  var result = "";
  if(days == 0 && hours == 0 && minutes == 0){
    result = "<span class='days'>now</span>";
  }
  else{
    result = result + " within "
    if(days > 0){
      result ="<span class='days'>";
      if(days === 1){
        result = result +  "1 day";
      }
      else{
        result = result + days + " days"
      }
      result = result + "</span>";
    }

    result = result + "<span class='hours'>";

    if(hours === 1){
      result = result + " " + "1 hour";
    }
    else{
      result = result + " " + hours + " hours"
    }
    result = result + "</span>";

    result = result + " and"

    result = result + "<span class='minutes'>";

    if(minutes === 1){
      result = result + " " + "1 min";
    }
    else{
      result = result + " " + minutes + " mins"
    }
    result = result + "</span>";
  }
  return {distance: distance, message: result};
}